module.exports = __webpack_public_path__ + "img/ic_satisfied_yellow.a66fea29.svg";